exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-info-container {\n  -webkit-animation: fadein 2s;\n          animation: fadein 2s;\n  background: #dfdfdf;\n  border-radius: 10px;\n  border: 1px solid #acacac;\n  bottom: 20px;\n  font-size: 18px;\n  min-height: 60px;\n  padding: 20px;\n  position: fixed;\n  right: 30px;\n  width: 60%;\n  z-index: 999; }\n  .cookie-info-container span {\n    display: inline-block;\n    padding-top: 14px; }\n\n@-webkit-keyframes fadein {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fadein {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/ui/cookie-info/cookie-info.component.scss
// module id = ../../../../../src/app/ui/cookie-info/cookie-info.component.scss
// module chunks = main